import jwtDecode from 'jwt-decode';

class AdminAuth {

    setJWTToken(auth0ResponseData) {
        localStorage.setItem('token', auth0ResponseData.accessToken);
        localStorage.setItem('expires_at', new Date().getTime() + auth0ResponseData.expiryIn * 1000);
    }

    loadJWTToken() {
        const token = localStorage.getItem('token');
        return (token !== null && typeof token !== 'udnefined');
    }

    getJWTToken() {
        return localStorage.getItem('token');
    }

    clearTokenFromLocalStorage() {
        localStorage.removeItem('token');
        localStorage.removeItem('expires_at');
    }

    getExpirationTimeFromToken(token) {
        const decodedToken = jwtDecode(token);
        return decodedToken.exp;
    }

    isAdminAuthenticated() {
        let expiresAt = JSON.parse(localStorage.getItem('expires_at'));
        if (new Date().getTime() < expiresAt) {
            return this.loadJWTToken();
        }

        return false;
    }
}

export default new AdminAuth();


// WEBPACK FOOTER //
// ./src/services/AdminAuth.js